var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SoftwareLicenseSelectionList',{ref:"list",attrs:{"disabled":"","software-asset-id":_vm.resourceId,"searchable":false,"show-no-data":false,"has-actions":false}})}
var staticRenderFns = []

export { render, staticRenderFns }